import { Component, Inject, OnInit } from "@angular/core";
import { Validators, FormBuilder } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { concat } from "rxjs";
import { map } from "rxjs/operators";
import { AdminService } from "src/app/injectable/admin.service";
import { GenericErrorModalService } from "src/app/injectable/generic-error-handling/generic-error-modal.service";
import { SenderItem } from "./sender-item";

@Component({
  selector: "app-modify-user-senders-dialog",
  templateUrl: "./modify-user-senders-dialog.component.html",
  styleUrls: ["./modify-user-senders-dialog.component.scss"],
})
export class ModifyUserSendersDialogComponent implements OnInit {
  availableSenders: SenderItem[];
  loading = false;

  modifyUserSendersForm = this.fb.group({
    idUser: [null, Validators.required],
    senders: [null],
  });

  constructor(
    public dialogRef: MatDialogRef<ModifyUserSendersDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data,
    private fb: FormBuilder,
    private adminService: AdminService,
    private genericErrorModalService: GenericErrorModalService
  ) {}

  ngOnInit(): void {
    concat(
      this.adminService.getAllSenders().pipe(
        map((value) => {
          this.availableSenders = value;
        })
      ),
      this.adminService.getAllUserSenders(this.data.user.id).pipe(
        map((value) => {
          this.availableSenders = this.availableSenders.map((item) => {
            const senderItem: SenderItem = new SenderItem(item);
            if (value.list.find((x) => x.idSender == senderItem.idSender))
              senderItem.selected = true;
            return senderItem;
          });
        })
      )
    ).subscribe(
      (response) => {
        this.loading = false;
        this.modifyUserSendersForm.patchValue({
          idUser: this.data.user.id,
          senders: this.availableSenders
            .filter((item) => item.selected)
            .map((item) => {
              return item.idSender;
            }),
        });
      },
      (err) => {
        this.loading = false;
        this.genericErrorModalService.open(
          "Errore nel caricamento della lista dei Sender",
          err
        );
      }
    );
  }

  onSubmit() {
    const formValue = this.modifyUserSendersForm.value;
    this.dialogRef.close(formValue);
  }

  closeCancelling() {
    this.dialogRef.close();
  }

  onItemClick(item: SenderItem) {
    item.chosen = !item.chosen;
  }

  onSwitchClick() {
    this.availableSenders = this.availableSenders.map((item) => {
      if (item.chosen) item.selected = !item.selected;
      item.chosen = false;
      return item;
    });
    this.modifyUserSendersForm.patchValue({
      idUser: this.data.user.id,
      senders: this.availableSenders
        .filter((item) => item.selected)
        .map((item) => {
          return item.idSender;
        }),
    });
  }
}
